import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Box,
  Chip,
  Collapse,
  TextField,
  Select,
  MenuItem,
  FormControl,
  Autocomplete,
  IconButton,
  RadioGroup,
  FormControlLabel,
  Radio,
  FormLabel,
} from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";
import React, { useState, useEffect } from "react";
import { get, post } from "../../../../utils/api";
import SelectField from "../../../../Components/Masters/SelectField";
import InputField from "../../../../Components/Masters/InputField";
import { Delete } from "@mui/icons-material";
import AddTable from "../../../Masters/Scope1/ProductMaster/AddTables";
import AddIcon from "@mui/icons-material/Add";
import BulkFileUpload from "../../FugitiveEmmissions/BulkFileUpload";

const BulkUpload = ({
  matchData,
  onClose,
  onConfirm,
  onAddItem,
  setMatchData,
  bulkUploadTable,
  onOpenAddEquipment,
  bulkuploadInputData,
  typeofemissions,
  url,
  simpleUnits,
  submitUrl,
  title,
  keyValue,
  options,
  addNew,
  setFormData,
  formData,
  jsonBulkUpload = [],
  bulkUploadUrl,
  setsnackOpen,
  fieldName,
}) => {
  console.log(bulkuploadInputData, "bulkuploadInputData", keyValue);
  const [processEmission, setProcessEmission] = useState([
    {
      processName: "",
      emissions: [{ emissionsName: "", unit: "", quantity: "" }],
    },
  ]);
  const [processTimeout, setProcessTimeout] = useState(null);
  const [units, setUnits] = useState([]);
  const [removeIndex, setRemoveIndex] = useState("");
  const [table, setTable] = useState([]);
  
  // Document upload state management
  const [finalJson, setFinalJson] = useState(jsonBulkUpload);
  const [uploadValidationErrors, setUploadValidationErrors] = useState([]);
  const [hasValidationBeenAttempted, setHasValidationBeenAttempted] = useState(false);
  
  // Document upload confirmation state
  const [documentUploadConfirmed, setDocumentUploadConfirmed] = useState(false);
  // Document upload type state
  const [documentUploadType, setDocumentUploadType] = useState("none"); // "none", "individual", "same"
  const [commonDocument, setCommonDocument] = useState(null);
  const [individualDocuments, setIndividualDocuments] = useState({});
  // State to show confirmation dialog for proceeding without documents
  const [showNoDocumentDialog, setShowNoDocumentDialog] = useState(false);
  const inputTableData = [
    {
      title: "Process Name",
      colwidth: "28%",
      filedName: "processes",
      placeholder: "Process Name",
    },
    {
      title: "Emission",
      field: "emissions",
      placeholder: "Emission",
    },
    {
      title: "Quantity",
      field: "quantity",
      type: "number",
      placeholder: "Enter Quantity",
    },
    {
      title: "Unit",
      field: "unit",
      type: "select",
      placeholder: "Unit",
    },
  ];
  const handleDelete = (index) => {
    if (formData.processes?.length <= 1) {
      return;
    }
    const process = formData?.processes?.[index];
    console.log(process, "process");
    if (process?.airEmissions?.length === 0 && process?.processName === "") {
      setFormData((prevState) => ({
        ...prevState,
        processes: prevState.processes?.filter((_, i) => i !== index), // Simplified filter
      }));

      setProcessEmission((prev) => prev.filter((_, i) => i !== index)); // Simplified filter
      setTable((prev) => prev.filter((_, i) => i !== index)); // Simplified filter
      setRemoveIndex("");
      setErrors((prev) => ({ ...prev }));
    } else {
      setRemoveIndex(index);
    }
  };

  const confirmRemoveRow = () => {
    setFormData((prevState) => ({
      ...prevState,
      processes: prevState.processes?.filter((_, i) => i !== removeIndex), // Simplified filter
    }));
  };
  const isFilled = () => {
    let data = formData?.processes?.[formData?.processes?.length - 1];
    console.log(formData, data, "formData");
    if (data?.processName !== "" && data?.airEmissions?.length !== 0)
      return false;
    return true;
  };
  const handleAdd = () => {
    const newItem = {
      processName: "",
      airEmissions: [],
      emissions: [{ emissionsName: "", unit: "", quantity: "" }],
    };

    setProcessEmission((prev) => [...prev, newItem]);
    setFormData((prevState) => ({
      ...prevState,
      processes: [...(prevState?.processes || []), newItem],
    }));

    // Also update the table state
    setTable((prev) => [
      ...prev,
      {
        index: prev.length,
        processName: "",
        airEmissions: [],
        emissions: [{ emissionsName: "", unit: "", quantity: "" }],
        colspan: 1,
      },
    ]);
  };
  const handleChangeEmission = async (name, value) => {
    const [baseField, field, rawIndex] = name.split(".");
    console.log(name, baseField, field, value, "handleChangeEmission");
    const index = parseInt(rawIndex, 10);

    setFormData((prevState) => {
      if (baseField === "processes") {
        return {
          ...prevState,
          [baseField]: prevState[baseField]?.map((item, idx) => {
            if (idx !== index) return item;
            if (field === "emissions") {
              const mappedEmissions = (value || []).map((val, idx) => {
                const previous = item.emissions?.[idx] || {};
                return {
                  emissionsName:
                    typeof val === "object"
                      ? val.emissionsName || val.name || val
                      : val,
                  unit: previous.unit || "",
                  quantity: previous.quantity || "",
                };
              });

              return {
                ...item,
                airEmissions: value || [],
                emissions: [...mappedEmissions],
              };
            }

            return {
              ...item,
              [field]: value,
            };
          }),
        };
      } else {
        return {
          ...prevState,
          [name]: value,
        };
      }
    });
    console.log(baseField, field, index, "baseField", errors);
    if (baseField === "processes") {
      setTable((prevTable) => {
        const updatedTable = [...prevTable];
        const emissionKey = `processes.emissions.${index}`;
        const emissions = value || [];
        console.log(emissions, "formData[emissionKey]");
        const rowIndex = updatedTable.findIndex((row) => row.index === index);

        if (rowIndex >= 0) {
          updatedTable[rowIndex].emissions = emissions.reduce(
            (acc, item, idx) => {
              if (!Array.isArray(acc)) acc = [];
              acc.push({
                emissionsName: item.name || item, // Fallback if item is a string
                quantity: item.quantity || "",
                unit: item.unit || "",
              });
              return acc;
            },
            []
          );
          updatedTable[rowIndex].colspan = emissions.length || 1;
        }

        return updatedTable;
      });
    }

    console.log(errors, baseField, "abcd");
    setErrors((prevState) => ({
      ...prevState,
      [`airEmissions.${index}`]: "", // clear specific field
    }));
  };
  useEffect(() => {
    if (formData.sampleBasis) {
      const unitOptions =
        simpleUnits.find(
          (unit) => Object.keys(unit)[0] === formData.sampleBasis
        )?.[formData.sampleBasis] || [];

      console.log("unitOptions:", unitOptions);
      setUnits(unitOptions);
    } else {
      setUnits([]);
    }
  }, [formData.sampleBasis, simpleUnits]);
  const [expandedRows, setExpandedRows] = useState({});
  const [errors, setErrors] = useState({});
  const [equipmentList, setEquipmentList] = useState([]);

  console.log(matchData, "matchData");
  useEffect(() => {
    if (options) {
      setEquipmentList(options);
    } else {
      const fetchEquipmentList = async () => {
        const response = await get(url);
        console.log(response.data?.data, "response.data?.data");
        const names = response.data?.data?.map((item) => item?.productName);
        setEquipmentList(names);
        console.log(response.data, names, "response.data");
      };
      fetchEquipmentList();
    }
  }, [url, options]);

  // Monitor jsonBulkUpload changes
  useEffect(() => {
    if (jsonBulkUpload && jsonBulkUpload.length > 0) {
      setFinalJson(jsonBulkUpload);
    }
  }, [jsonBulkUpload]);

  // Document upload handler functions
  const handleDocumentUploadConfirmation = (confirmed) => {
    setDocumentUploadConfirmed(confirmed);
    
    if (!confirmed) {
      // Reset document upload type to "none" if user chooses not to upload
      setDocumentUploadType("none");
    }
  };

  const handleDocumentUploadTypeChange = (event) => {
    setDocumentUploadType(event.target.value);
    
    setCommonDocument(null);
    setIndividualDocuments({});
  };

  const handleCommonDocumentChange = (files) => {
    setCommonDocument(files);
    
    // Update finalJson with common document for all entries
    if (finalJson && finalJson.length > 0) {
      const updated = finalJson.map((entry) => ({
        ...entry,
        "Document (optional)": files,
      }));
      setFinalJson(updated);
    }
  };

  const handleIndividualDocumentChange = (index, files) => {
    setIndividualDocuments((prev) => ({
      ...prev,
      [index]: files,
    }));
    
    // Update finalJson with individual document for specific entry
    if (finalJson && finalJson.length > 0) {
      const updated = finalJson.map((entry, i) => {
        if (i === index) {
          return {
            ...entry,
            "Document (optional)": files,
          };
        }
        return entry;
      });
      setFinalJson(updated);
    }
  };

  const handleClearCommonDocument = () => {
    setCommonDocument(null);
    
    // Update finalJson to clear common document for all entries
    if (finalJson && finalJson.length > 0) {
      const updated = finalJson.map((entry) => ({
        ...entry,
        "Document (optional)": null,
      }));
      setFinalJson(updated);
    }
  };

  const handleClearIndividualDocument = (index) => {
    setIndividualDocuments((prev) => {
      const newDocs = { ...prev };
      delete newDocs[index];
      return newDocs;
    });
    
    // Update finalJson to clear individual document for specific entry
    if (finalJson && finalJson.length > 0) {
      const updated = finalJson.map((entry, i) => {
        if (i === index) {
          return {
            ...entry,
            "Document (optional)": null,
          };
        }
        return entry;
      });
      setFinalJson(updated);
    }
  };

  const handleProceedWithoutDocuments = () => {
    setShowNoDocumentDialog(false);
    performUpload();
  };

  const handleCancelProceedWithoutDocuments = () => {
    setShowNoDocumentDialog(false);
  };

  const validateUploadData = () => {
    const validationErrors = [];

    // Check if user wants to upload documents but hasn't uploaded any
    if (documentUploadConfirmed && documentUploadType === "none") {
      validationErrors.push("Please select a document upload type when document upload is confirmed.");
    }

    return validationErrors;
  };

  const performUpload = async () => {
    // Use jsonBulkUpload as fallback if finalJson is empty
    const dataToUse = finalJson && finalJson.length > 0 ? finalJson : jsonBulkUpload;

    // Prepare data structure for upload
    const uploadData = {
      excelData: dataToUse,
      documentUploadType: documentUploadType,
      commonDocument: commonDocument,
      individualDocuments: individualDocuments,
    };

    console.log("Final upload data structure:", uploadData);

    if (bulkUploadUrl) {
      await post(bulkUploadUrl, uploadData)
        .then((res) => {
          // Clear validation errors and reset validation attempted flag on successful upload
          setUploadValidationErrors([]);
          setHasValidationBeenAttempted(false);
          setsnackOpen({
            open: true,
            message: res.data.message,
            severity: "success",
          });
          onConfirm();
          onClose();
        })
        .catch((err) => {
          const errMessage = err.response?.data?.details
            ?.map((el) => el?.error)
            ?.join(",");
          if (err?.response?.status === 422) {
          }
          setsnackOpen({
            open: true,
            message: errMessage ?? err.response?.data?.message ?? "Network Error",
            severity: "error",
          });
        });
    } else {
      // Fallback to original onConfirm if no bulkUploadUrl provided
      onConfirm();
    }
  };

  const handleSubmit = async () => {
    // Mark that validation has been attempted
    setHasValidationBeenAttempted(true);

    const validationErrors = validateUploadData();
    console.log(validationErrors, "validationErrors");

    if (validationErrors.length > 0) {
      setUploadValidationErrors(validationErrors);
      return;
    }

    // Check if user wants to upload documents but hasn't uploaded any
    const needsDocs = documentUploadConfirmed && documentUploadType !== "none";

    if (needsDocs) {
      const hasCommonDoc = documentUploadType === "same" && commonDocument && commonDocument.length > 0;
      const hasIndividualDocs = documentUploadType === "individual" && 
        Object.keys(individualDocuments).length > 0 &&
        Object.values(individualDocuments).some((docs) => docs && docs.length > 0);

      if (!hasCommonDoc && !hasIndividualDocs) {
        setShowNoDocumentDialog(true);
        return;
      }
    }

    // If no dialog is needed, proceed with upload
    await performUpload();
  };

  if (!matchData || matchData.length === 0) {
    return null;
  }

  console.log(matchData, "matchData");
  const handleFormChange = (index, field, value) => {
    setFormData((prev) => ({
      ...prev,
      [index]: {
        ...prev[index],
        [field]: value,
      },
    }));

    // If "Add New Equipment" is selected, expand the row
    if (field === "selectedEquipment" && value === "add_new") {
      setExpandedRows((prev) => ({
        ...prev,
        [index]: true,
      }));
    }

    // If any other equipment is selected, close the expanded row and clear form fields (but keep selectedEquipment)
    if (field === "selectedEquipment" && value !== "add_new" && value !== "") {
      setExpandedRows((prev) => ({
        ...prev,
        [index]: false,
      }));

      // Clear form fields but keep the selectedEquipment value
      setFormData((prev) => ({
        ...prev,
        [index]: {
          selectedEquipment: value,
        },
      }));
    }
  };

  const validateForm = (index) => {
    const data = formData[index] || {};
    const newErrors = {};

    if (!data.equipmentName?.trim()) {
      newErrors.equipmentName = "Equipment name is required";
    }
    if (!data.equipmentType?.trim()) {
      newErrors.equipmentType = "Equipment type is required";
    }
    if (!data.quantityConsumed || data.quantityConsumed <= 0) {
      newErrors.quantityConsumed = "Valid quantity is required";
    }
    if (!data.calorificValue || data.calorificValue <= 0) {
      newErrors.calorificValue = "Valid calorific value is required";
    }

    setErrors((prev) => ({
      ...prev,
      [index]: newErrors,
    }));

    return Object.keys(newErrors).length === 0;
  };

  const handleFormFieldChange = (index, field, value) => {
    setFormData((prev) => ({
      ...prev,
      [index]: {
        ...prev[index],
        [field]: value,
      },
    }));

    // Clear error when user starts typing
    if (errors[index]?.[field]) {
      setErrors((prev) => ({
        ...prev,
        [index]: {
          ...prev[index],
          [field]: "",
        },
      }));
    }
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    console.log(name, value, "process checking");
    const [baseField, field, rawIndex] = name.split(".");
    console.log(baseField, field, rawIndex, "process 1 checking");
    // Update form data
    if (name === "sampleQuantity") {
      if (!/^\d*\.?\d*$/.test(value)) return;
    }

    const index = parseInt(rawIndex, 10);

    setFormData((prevState) => {
      if (baseField === "processes") {
        return {
          ...prevState,
          [baseField]: prevState[baseField]?.map((item, idx) => {
            return idx === index ? { ...item, [field]: value } : item;
          }),
        };
      } else {
        return {
          ...prevState,
          [name]: value,
        };
      }
    });

    // Clear errors for this field
    setErrors((prevState) => ({
      ...prevState,
      [name]: "",
    }));

    if (baseField === "processes") {
      if (processTimeout) clearTimeout(processTimeout);

      const newTimeout = setTimeout(async () => {
        if (value.trim() === "") return;

        setTable((prevTable) => {
          const updatedTable = [...prevTable];
          const rowIndex = updatedTable.findIndex((row) => row.index === index);

          if (rowIndex >= 0) {
            // Update existing row
            updatedTable[rowIndex].processName = value;
          } else {
            // This else block was creating new rows unnecessarily
            // We shouldn't need this since we're only updating existing rows
            console.warn("Trying to update non-existent row");
          }

          return updatedTable;
        });
      }, 600); // Debounce delay

      setProcessTimeout(newTimeout);
    }
  };
  console.log("formdata");
  const renderInputField = (el) => {
    console.log(el, "el");
    if (Array.isArray(el)) {
      const hasHeader = el.some((item) => item.header);
      return (
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            flexDirection: "row",
            gap: "8px",
            width: "100%",
          }}
        >
          {hasHeader && (
            <Typography
              variant="subtitle1"
              sx={{ fontWeight: "bold", width: "100%", mb: 1 }}
            >
              {el.find((item) => item.header)?.header}
            </Typography>
          )}

          {el.map((item) => {
            return (
              <Box sx={{ width: item.colwidth || "100%" }}>
                {item.type === "select" ? (
                  <SelectField
                    title={item.title}
                    name={item.fieldName}
                    value={formData[item.fieldName]}
                    //   handleChange={handleCountryChange}
                    handleChange={handleChange}
                    options={item.options}
                    errors={errors[item.fieldName]}
                  />
                ) : item.fieldName === "unit" ? (
                  <SelectField
                    title={item.title}
                    name={item.fieldName}
                    value={formData[item.fieldName]}
                    //   handleChange={handleCountryChange}
                    handleChange={handleChange}
                    options={units || []}
                    errors={errors[item.fieldName]}
                  />
                ) : (
                  <InputField
                    title={item.title}
                    handleChange={handleChange}
                    placeholder={item.placeholder}
                    value={formData[item.fieldName] || ""}
                    errors={errors[item.fieldName]}
                    fieldName={item.fieldName}
                  />
                )}
              </Box>
            );
          })}
        </Box>
      );
    }

    if (el.header) {
      return (
        <Typography
          // key={idx}
          variant="subtitle1"
          sx={{ fontWeight: "bold", width: "100%", mt: 2 }}
        >
          {el.header}
        </Typography>
      );
    }
  };
  return (
    <>
    <Dialog
      open={bulkUploadTable}
      onClose={onClose}
      maxWidth="lg"
      sx={{
        "& .MuiDialog-paper": {
          width: "60%",
          margin: "16px",
          maxHeight: "calc(100% - 32px)",
          zIndex: 1000,
        },
      }}
    >
      <DialogTitle>Review Bulk Upload Data</DialogTitle>
      <DialogContent>
        <Typography variant="body2" sx={{ mb: 2 }}>
          Review the matched and unmatched equipment data. Add unmatched items
          individually.
        </Typography>

        <TableContainer component={Paper} sx={{ maxHeight: 400 }}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell sx={{ fontWeight: "bold", width: "40%" }}>
                  Data Entered
                </TableCell>
                <TableCell sx={{ fontWeight: "bold", width: "40%" }}>
                  Master Data
                </TableCell>
              </TableRow>
            </TableHead>
            <TableHead>
              <TableRow>
                <TableCell sx={{ fontWeight: "bold", width: "30%" }}>
                  {title ? title : "Equipment Name"}
                </TableCell>
                <TableCell sx={{ fontWeight: "bold", width: "30%" }}>
                  {title ? title : "Equipment Name"}
                </TableCell>
                <TableCell sx={{ fontWeight: "bold", width: "20%" }}>
                  Action
                </TableCell>
                {documentUploadConfirmed && documentUploadType === "individual" && (
                  <TableCell sx={{ fontWeight: "bold", width: "20%" }}>
                    Document
                  </TableCell>
                )}
              </TableRow>
            </TableHead>
            <TableBody>
              {matchData.map((item, index) => (
                <>
                  <TableRow key={index}>
                    <TableCell>
                      {keyValue ? item?.[keyValue] : item.equipment}
                    </TableCell>
                    <TableCell>
                      {item.matched ? (
                        <Chip label="Matched" color="success" size="small" />
                      ) : (
                        <FormControl
                          size="small"
                          sx={{ minWidth: 120, width: "80%" }}
                        >
                          <Select
                            value={formData[index]?.selectedEquipment || ""}
                            onChange={(e) =>
                              handleFormChange(
                                index,
                                "selectedEquipment",
                                e.target.value
                              )
                            }
                            fullWidth
                            displayEmpty
                            disabled={item.matched}
                          >
                            <MenuItem value="">Tap to Select</MenuItem>
                            {addNew !== false && (
                              <MenuItem value="add_new">
                                Add New Product +
                              </MenuItem>
                            )}
                            {equipmentList &&
                              equipmentList.map((item, index) => {
                                return <MenuItem value={item}>{item}</MenuItem>;
                              })}
                          </Select>
                        </FormControl>
                      )}
                    </TableCell>
                    <TableCell>
                      {!item.matched &&
                        (formData[index]?.selectedEquipment === "add_new" ||
                        expandedRows[index] ? (
                          <Button
                            variant="contained"
                            size="small"
                            onClick={() => {
                              setExpandedRows((prev) => ({
                                ...prev,
                                [index]: !prev[index],
                              }));
                            }}
                            sx={{ minWidth: "80px" }}
                          >
                            {expandedRows[index] ? "Close" : "Open"}
                          </Button>
                        ) : null)}
                    </TableCell>
                    {documentUploadConfirmed && documentUploadType === "individual" && (
                      <TableCell>
                        <BulkFileUpload
                          filesList={individualDocuments[index] || []}
                          handleChange={handleIndividualDocumentChange}
                          handleClear={handleClearIndividualDocument}
                          index={index}
                        />
                      </TableCell>
                    )}
                  </TableRow>
                  {/* Expandable form row */}
                  <TableRow>
                    <TableCell
                      style={{ paddingBottom: 0, paddingTop: 0 }}
                      colSpan={documentUploadConfirmed && documentUploadType === "individual" ? 4 : 3}
                    >
                      <Collapse
                        in={expandedRows?.[index]}
                        timeout="auto"
                        unmountOnExit
                      >
                        <Box>
                          {bulkuploadInputData
                            .slice(0, -1)
                            .map((el, index) => renderInputField(el))}
                          {processEmission.map((item, index) => {
                            return (
                              <Box
                                sx={{
                                  display: "flex",
                                  flexDirection: "row",
                                  gap: "8px",
                                  width: "100%",
                                  alignItems: "flex-start", // Align items at the top
                                  position: "relative", // Make this a positioning context
                                  mb: "-1.2rem",
                                }}
                              >
                                {/* Main content box */}
                                <Box
                                  sx={{
                                    display: "flex",
                                    flexWrap: "wrap",
                                    flexDirection: "row",
                                    gap: "8px",
                                    width: "calc(100% - 40px)", // Reserve space for delete button
                                  }}
                                >
                                  {bulkuploadInputData[3].map((item, idx) => (
                                    <Box
                                      sx={{ width: item.colwidth || "100%" }}
                                    >
                                      {console.log(
                                        item,
                                        formData?.processes,
                                        "item1"
                                      )}

                                      {item.fieldName ===
                                      "processes.emissions" ? (
                                        <>
                                          <Typography
                                            variant="subtitle1"
                                            sx={{ fontWeight: "bold", mt: 1 }}
                                          >
                                            {item.title}
                                          </Typography>
                                          <Autocomplete
                                            multiple
                                            disablePortal
                                            size="small"
                                            displayEmpty
                                            options={typeofemissions}
                                            //   disabled={
                                            //     formData.processes[index]
                                            //       ?.processName === ""
                                            //   }
                                            //   value={
                                            //     formData?.processes[index]
                                            //       ?.airEmissions || []
                                            //   }
                                            onChange={(_, newValue) =>
                                              handleChangeEmission(
                                                `${item.fieldName}.${index}`,
                                                newValue
                                              )
                                            }
                                            getOptionLabel={(option) => option}
                                            renderTags={() => null}
                                            renderInput={(params) => (
                                              <TextField
                                                {...params}
                                                variant="outlined"
                                                placeholder={
                                                  (
                                                    formData?.processes?.[idx]
                                                      ?.airEmissions || []
                                                  ).length === 0
                                                    ? "Tap to Select"
                                                    : ""
                                                }
                                                error={
                                                  !!errors[
                                                    `airEmissions.${index}`
                                                  ]
                                                }
                                                // helperText={errors[`airEmissions.${index}`]}
                                              />
                                            )}
                                            sx={{
                                              width: "100%",
                                              "& .MuiAutocomplete-inputRoot": {
                                                height: 40,
                                                alignItems: "center",
                                              },
                                              "& .MuiAutocomplete-tag": {
                                                display: "none",
                                              },
                                            }}
                                          />
                                          {errors[`airEmissions.${index}`] && (
                                            <Typography
                                              variant="body2"
                                              color="#D34040"
                                            >
                                              {errors[`airEmissions.${index}`]}
                                            </Typography>
                                          )}
                                          <Box
                                            sx={{
                                              display: "flex",
                                              flexWrap: "wrap",
                                              minHeight: "40px", // Fixed height for chip container
                                              alignItems: "flex-start",
                                              marginBottom: "8px", // Add some space below
                                            }}
                                          >
                                            {formData?.processes?.[
                                              idx
                                            ]?.airEmissions?.map((value) => (
                                              <Chip
                                                key={value}
                                                label={value}
                                                sx={{
                                                  bgcolor: "#1C486B",
                                                  color: "white",
                                                  height: "28px",
                                                  m: 0.25,
                                                  "& .MuiChip-deleteIcon": {
                                                    color: "white",
                                                    "&:hover": {
                                                      color: "white",
                                                    },
                                                  },
                                                }}
                                                onDelete={() =>
                                                  handleChangeEmission(
                                                    `${item.fieldName}.${index}`,
                                                    formData?.processes[
                                                      index
                                                    ]?.airEmissions?.filter(
                                                      (v) => v !== value
                                                    )
                                                  )
                                                }
                                              />
                                            ))}
                                          </Box>
                                        </>
                                      ) : (
                                        <InputField
                                          title={item.title}
                                          handleChange={handleChange}
                                          placeholder={item.placeholder}
                                          value={
                                            formData?.processes?.processName?.[
                                              index
                                            ] || ""
                                          }
                                          errors={
                                            errors[
                                              `${item.fieldName}?.${index}`
                                            ]
                                          }
                                          helperText={
                                            errors[
                                              `${item.fieldName}?.${index}`
                                            ]
                                          }
                                          fieldName={`${item.fieldName}.${index}`}
                                        />
                                      )}
                                    </Box>
                                  ))}
                                </Box>

                                {/* Delete button positioned absolutely */}
                                <IconButton
                                  sx={{
                                    position: "absolute",
                                    right: 0,
                                    top: 0,
                                    mt: 4,
                                    // ml: "0.5rem"
                                  }}
                                  disabled={formData?.processes?.length === 1}
                                  onClick={() => handleDelete(index)}
                                  color="error"
                                >
                                  <Delete />
                                </IconButton>
                              </Box>
                            );
                          })}
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                          >
                            <Button
                              disabled={isFilled()}
                              variant="contained"
                              onClick={handleAdd}
                              sx={{
                                mt: "0rem",
                                backgroundColor: "#1C486B",
                                color: "white",
                              }}
                            >
                              <AddIcon />
                              Add New Process
                            </Button>
                          </Box>
                        </Box>
                        <Box>
                          <AddTable
                            inputData={inputTableData}
                            title={"Emission Release in Processes"}
                            table={table || [{}]}
                            formData={formData}
                            setFormData={setFormData}
                            setTable={setTable}
                            units={units}
                            errors={errors}
                            setErrors={setErrors}
                          />
                        </Box>
                      </Collapse>
                    </TableCell>
                  </TableRow>
                </>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        {/* Document Upload Section */}
        <Box
          sx={{ mt: 3, p: 2, border: "1px solid #e0e0e0", borderRadius: 1 }}
        >
          <Typography variant="h6" sx={{ mb: 2, fontWeight: "bold" }}>
            Document Upload
          </Typography>
          <Box>
            <FormControl component="fieldset">
              <FormLabel component="legend">
                Do you want to upload document?
              </FormLabel>
              <RadioGroup
                value={documentUploadConfirmed ? "yes" : "no"}
                onChange={(e) =>
                  handleDocumentUploadConfirmation(e.target.value === "yes")
                }
                row
              >
                <FormControlLabel
                  value="yes"
                  control={<Radio />}
                  label="Yes"
                />
                <FormControlLabel value="no" control={<Radio />} label="No" />
              </RadioGroup>
            </FormControl>
          </Box>
          {documentUploadConfirmed && (
            <FormControl component="fieldset" sx={{ mb: 2, mt: 2 }}>
              <FormLabel component="legend">Document Upload Type</FormLabel>
              <RadioGroup
                value={documentUploadType}
                onChange={handleDocumentUploadTypeChange}
                row
              >
                <FormControlLabel
                  value="same"
                  control={<Radio />}
                  label="Same File for All Records"
                />
                <FormControlLabel
                  value="individual"
                  control={<Radio />}
                  label="Individual File for Each Record"
                />
              </RadioGroup>
            </FormControl>
          )}

          {documentUploadConfirmed && documentUploadType === "same" && (
            <Box sx={{ mb: 2 }}>
              <Typography variant="body2" sx={{ mb: 1 }}>
                Upload a single document that will be associated with all
                records:
              </Typography>
              <BulkFileUpload
                filesList={commonDocument}
                handleChange={handleCommonDocumentChange}
                handleClear={handleClearCommonDocument}
              />
            </Box>
          )}

          {documentUploadConfirmed && documentUploadType === "individual" && (
            <Box sx={{ mb: 2 }}>
              <Typography variant="body2" sx={{ mb: 1 }}>
                Upload individual documents for each record. Documents will
                be added as a new column in the table above.
              </Typography>
            </Box>
          )}
        </Box>

        {/* Validation Error Display - Only show after validation has been attempted */}
        {hasValidationBeenAttempted && uploadValidationErrors.length > 0 && (
          <Box
            sx={{
              mt: 2,
              p: 2,
              backgroundColor: "#ffebee",
              borderRadius: 1,
              border: "1px solid #f44336",
            }}
          >
            <Typography
              variant="h6"
              color="error"
              sx={{ mb: 1, fontWeight: "bold" }}
            >
              Error:
            </Typography>
            {uploadValidationErrors.map((error, index) => (
              <Typography
                key={index}
                variant="body2"
                color="error"
                sx={{ mb: 0.5 }}
              >
                • {error}
              </Typography>
            ))}
          </Box>
        )}
      </DialogContent>
      <DialogActions sx={{ padding: "1rem" }}>
        <Button
          onClick={onClose}
          variant="outlined"
          color="primary"
          sx={{ marginRight: "1rem" }}
        >
          Cancel
        </Button>
        <Button onClick={handleSubmit} variant="contained" color="primary">
          Confirm Upload
        </Button>
      </DialogActions>
    </Dialog>

    {/* Confirmation Dialog for Proceeding Without Documents */}
    <Dialog
      open={showNoDocumentDialog}
      onClose={handleCancelProceedWithoutDocuments}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
        >
          <Typography variant="h6">No Documents Uploaded</Typography>
          <IconButton
            onClick={handleCancelProceedWithoutDocuments}
            size="small"
          >
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Typography variant="body1" sx={{ mb: 2 }}>
          You have selected to upload documents but haven't uploaded any files.
        </Typography>
        <Typography variant="body1" sx={{ mb: 2 }}>
          Do you want to proceed without uploading documents?
        </Typography>
        <Typography variant="body2" color="text.secondary">
          You can still upload documents later if needed.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ padding: "1rem" }}>
        <Button
          onClick={handleCancelProceedWithoutDocuments}
          variant="outlined"
          color="primary"
          sx={{ marginRight: "1rem" }}
        >
          Upload Documents
        </Button>
        <Button
          onClick={handleProceedWithoutDocuments}
          variant="contained"
          color="primary"
        >
          Proceed Without Documents
        </Button>
      </DialogActions>
    </Dialog>
  </>
  );
};

export default BulkUpload;
